import { React, useEffect, useState, } from "react";
import { Link, useParams } from "react-router-dom";
import AOS from "aos";
import Banner from "../Components/Banner";
import IndustryDescription from "./Industry/IndustryDescription"
import Chatwithus from "../Components/chatwithus";
import Workwithus from "../Components/Industries/Workwithus";
import TestimonialSlider from "../Components/testimonial_slider";
import Clients from "../Components/Industries/Clients";
// import occupationalservices from '../../images/Industries/micro-landing/occupational_services.png'
import Testimonial from "../Components/Testimonials";
import FormModal from '../Components/FormModal';

//images
import it_banner from '../images/banner_images/laptop/it.png'
import retail_banner from '../images/Industries/micro-landing/retail_banner.png'
import logistics_banner from '../images/Industries/micro-landing/logistics_banner.png'
import development_banner from '../images/Industries/micro-landing/development_banner.png'
import energy_banner from '../images/Industries/micro-landing/energy_banner.png'
import commercial_banner from '../images/Industries/micro-landing/commercial_banner.png'
import temp_banner from '../images/Industries/micro-landing/temp_banner.png'
import polygon from "../images/Industries/micro-landing/polygon.png"
import brokerage from "../images/Industries/micro-landing/brokerage.png"
import liaison from "../images/Industries/micro-landing/liaison.png"
import plus from "../images/Industries/micro-landing/plus.png"
import minus from "../images/Industries/micro-landing/minus.png"
import Industries_Slider from "../Components/Industries/Industries_Slider";
import ServiceType from "../Components/Industries/Servicetypes";
import mob_it_banner from '../images/banner_images/mobile/mobile_itbanner.png'
import mob_commercial_banner from '../images/banner_images/mobile/mobile_commercial.png'
import Button from "../Components/Button";




function B2B_Sublanding() {

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle() {
        setModalToggle(!modalToggle);
    }

    const params = useParams();
    const path = params.micro_id;


    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [serviceCategory, setserviceCategory] = useState("consultation");
    const [brokeragetoggle, setbrokeagetoggle] = useState("acquisition");
    const [liaisontoggle, setliaisontoggle] = useState("bpa");

    const bannerdata = {
        it: {
            image: it_banner,
            mob_banner: mob_it_banner,
            title: "Smart Spaces for the Modern Workforce",
            subtitle: "Private offices. Co-working hubs. Spaces that grow with you.",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"

        },

        retail: {
            image: retail_banner,
            mob_banner: retail_banner,
            title: "Smarter Locations. Stronger Returns.",
            subtitle: "We identify and deliver retail spaces with proven visibility and traffic, so your outlet grows from day one.",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        logistics: {
            image: logistics_banner,
            mob_banner: logistics_banner,
            title: "Land & Logistics. Anchored to Your Supply Chain.",
            subtitle: "Strategic locations and smart solutions to keep operations seamless",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        development: {
            image: development_banner,
            mob_banner: development_banner,
            title: "Location Anchoring for Your Next Development",
            subtitle: "From micromarket to launch, every step aligned with market demand.",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[600px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        commercial: {
            image: commercial_banner,
            mob_banner: mob_commercial_banner,
            title: "Work.Play.Shop",
            subtitle: "Work and commercial spaces for rent, lease & purchase",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        energy: {
            image: energy_banner,
            mob_banner: energy_banner,
            title: "Empowering Renewable Growth",
            subtitle: "Harness the power of wind and solar through strategic land aggregation.",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        manufacturing: {
            image: temp_banner,
            title: "Testing",
            subtitle: "Subtitle testing!!!",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        },
        hospitality: {
            image: "",
            title: "",
            subtitle: "",
            textposition: "",
            button_name: "Explore our Services",
            button_design: "filled",
            button_action: "scroll",
            button_attribute: "solution-section"
        }

    }

    return (
        <>
            <Banner
                img={bannerdata[path].image}
                mimg={bannerdata[path].mob_banner}
                heading={bannerdata[path].title}
                subheading={bannerdata[path].subtitle}
                textposition={bannerdata[path].textposition}
                renderButton={() => (
                    <Button name={bannerdata[path].button_name} design={bannerdata[path].button_design} action={bannerdata[path].button_action} section_id={bannerdata[path].button_attribute} />
                )}
            />


            <IndustryDescription />

            {/* Service we offer */}

            <div className="max-w-7xl mx-auto py-20 hidden">
                <h1 className="industry-section-heading text-center" data-aos="fade-up">Service we offer</h1>

                <div className="max-w-7xl mx-auto mt-20 mb-0 px-5 " data-aos="fade-up" data-aos-duration="1000">
                    <div className="flex flex-row justify-center sm:gap-x-[40px] gap-x-5 items-center">
                        <div className="relative">
                            <button
                                className={
                                    serviceCategory === "consultation"
                                        ? "bg-[#FAE970] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#17212B] text-[16px] sm:text-[24px] font-bold leading-[25.6px] sm:leading-[42px]  text-center"
                                        : "bg-[#F6F6F6] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#939393] sm:text-[24px] text-[16px] font-medium sm:leading-[42px] leading-[25.6px] text-center"
                                }
                                onClick={() => {
                                    setserviceCategory("consultation");
                                }}
                            >
                                Consultation
                            </button>
                            <img className={serviceCategory === "consultation" ? "absolute" : "hidden"}
                                src={polygon}
                                alt="polygon"
                            />
                        </div>

                        <div className="relative">
                            <button
                                className={
                                    serviceCategory === "execution"
                                        ? "bg-[#FAE970] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#17212B] sm:text-[24px] text-[16px] font-bold leading-[42px] tracking-[1px] text-center"
                                        : "bg-[#F6F6F6] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#939393] sm:text-[24px] text-[16px] font-medium sm:leading-[42px] leading-[25.6px]  text-center"
                                }
                                onClick={() => {
                                    setserviceCategory("execution");
                                }}
                            >
                                Execution
                            </button>
                            <img
                                className={serviceCategory === "execution" ? "absolute" : "hidden"}
                                src={polygon}
                                alt="polygon"
                            />
                        </div>

                        <div className="relative">
                            <button
                                className={
                                    serviceCategory === "dealclosure"
                                        ? "bg-[#FAE970] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#17212B] sm:text-[24px] text-[16px] font-bold leading-[42px] tracking-[1px] text-center"
                                        : "bg-[#F6F6F6] sm:w-[301px] sm:h-[70px] w-[100px] h-[50px] rounded-tr-lg rounded-tl-lg font-[Lato] text-[#939393] sm:text-[24px] text-[16px] font-medium sm:leading-[42px] leading-[25.6px]  text-center"
                                }
                                onClick={() => {
                                    setserviceCategory("dealclosure");
                                }}
                            >
                                Deal Closure
                            </button>
                            <img
                                className={serviceCategory === "dealclosure" ? "absolute" : "hidden"}
                                src={polygon}
                                alt="polygon"
                            />
                        </div>
                    </div>
                    <hr className="border-[#FAE970] border-t-[3px] w-[80%] mx-auto sm:w-full sm:mx-none" />
                </div>

                {/* Brokerage Service */}
                <div className="max-w-5xl mx-auto mt-24" >
                    <div className="flex flex-row justify-between">
                        <div className="relative">
                            <img className="w-[443px] h-full" src={brokerage} alt="brokerage_image" />
                            <h2 className="font-[Lato] text-white leading-[57px] tracking-[1.341px] font-bold text-[46px] absolute bottom-5 translate-x-1/4 uppercase">Brokerage</h2>
                        </div>

                        <div className="flex flex-col gap-y-9 w-1/2" data-aos="fade-up">
                            <div className="w-full flex flex-row justify-between items-center px-7 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl" onClick={() => { setbrokeagetoggle("acquisition") }} >
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">Acquisition</h2>
                                <img className={brokeragetoggle != "acquisition" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={brokeragetoggle === "acquisition" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* Acquisition Content Block */}
                            <div className={brokeragetoggle === "acquisition" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>

                            <div className="w-full flex flex-row justify-between items-center px-9 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl " onClick={() => { setbrokeagetoggle("aggregation") }}>
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">Aggregation</h2>
                                <img className={brokeragetoggle != "aggregation" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={brokeragetoggle === "aggregation" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* Aggregation Content Block */}
                            <div className={brokeragetoggle === "aggregation" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>

                            <div className="w-full flex flex-row justify-between items-center px-9 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl" onClick={() => { setbrokeagetoggle("dealclosure") }}>
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">Deal Closure</h2>
                                <img className={brokeragetoggle != "dealclosure" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={brokeragetoggle === "dealclosure" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* Deal Closure Content Block */}
                            <div className={brokeragetoggle === "dealclosure" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>



                        </div>
                    </div>
                </div>

                {/* Liaison Service */}
                <div className="max-w-5xl mx-auto mt-24">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col items-center gap-y-9 w-1/2" data-aos="fade-up">
                            <div className="w-full flex flex-row justify-between items-center px-9 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl" onClick={() => { setliaisontoggle("bpa") }} >
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">Building Plan Approval</h2>
                                <img className={liaisontoggle != "bpa" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={liaisontoggle === "bpa" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* BPA Content Block */}
                            <div className={liaisontoggle === "bpa" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>

                            <div className="w-full flex flex-row justify-between items-center px-9 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl" onClick={() => { setliaisontoggle("noc") }}>
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">No Objection Certificate</h2>
                                <img className={liaisontoggle != "noc" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={liaisontoggle === "noc" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* NOC Content Block */}
                            <div className={liaisontoggle === "noc" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>

                            <div className="w-full flex flex-row justify-between items-center px-9 py-5 shadow-xl border-[#C1C1C1] border-[1px] rounded-xl" onClick={() => { setliaisontoggle("luc") }}>
                                <h2 className="font-[Lato] text-[#5F5D5E] text-[22px] font-normal leading-[26px]">Land Use Change</h2>
                                <img className={liaisontoggle != "luc" ? "w-[20px] h-[20px]" : "hidden"} src={plus} alt="plus_icon" />
                                <img className={liaisontoggle === "luc" ? "w-[20px] h-[20px]" : "hidden"} src={minus} alt="minus_icon" />
                            </div>

                            {/* LOC Content Block */}
                            <div className={liaisontoggle === "luc" ? "block px-7" : "hidden"}>
                                <p className="font-[Lato] text-[#757575] text-[16px]">Qui esse officia minim sunt excepteur duis officia id ea ullamco.Elit dolor eu et irure dolor commodo sint nisi consequat.</p>
                            </div>



                        </div>

                        <div className="relative">
                            <img className="w-[443px] h-full" src={liaison} alt="brokerage_image" />
                            <h2 className="font-[Lato] text-black leading-[57px] tracking-[1.341px] font-bold text-[46px] absolute bottom-5 translate-x-1/2 uppercase">Liaison</h2>
                        </div>
                    </div>
                </div>

            </div>


            <div className={path === "retail" || path === "commercial" || path === "logistics" || path === "it" || path === "energy" || path === "development" ? "block" : "hidden"}>
                <ServiceType />
            </div>

            <Workwithus />

            <TestimonialSlider />

            <Industries_Slider />

            <Clients />

            <Chatwithus />

            <FormModal
                modal={modalToggle}
                active={toggle}
            />


        </>
    )
}


export default B2B_Sublanding;